import {NamaPresenter} from "./NamaPresenter";
import {ajaxJSON} from "../common/NamaCommon";
import * as ts from "../common/Translator";
import ReportWizardEditorTemplate from "../compiled-templates/ReportWizardEditorTemplate";
import {NamaKonvaCanvas} from "./NamaKonvaCanvas";
import Konva from "konva/cmj/index";
import {NamaRouterInstance} from "./NamaRouter";
import {EditPlace} from "./places";
import * as ViewMode from "../constants/ViewMode";
import * as notifier from "../common/ErrorsNotification";
import {APP_URL} from "../constants/GUIDevMode";


export class ReportWizardEditorPresenter extends NamaPresenter {
    constructor(place) {
        super(place);
    }

    start() {
        let that = this;
        that.initEditor();
        that.reportWizardId = that.place.reportWizardId;
        that.entity = that.place.entityType;
        that.bandSelectorWidth = 20;
        that.enumsProperties = [{
            id: "stretchType",
            name: "Stretch Type",
            dataType: 'Enum',
            values: [
                {text: "", value: ""},
                {text: "No Stretch", value: "NoStretch"},
                {text: "Relative To Tallest Object", value: "RelativeToTallestObject"},
                {text: "Relative To Band Height", value: "RelativeToBandHeight"},
                {text: "Element Group Height", value: "ElementGroupHeight"},
                {text: "Element Group Bottom", value: "ElementGroupBottom"},
                {text: "Element Group Bottom", value: "ElementGroupBottom"},
                {text: "Container Height", value: "ContainerHeight"},
                {text: "Container Bottom", value: "ContainerBottom"},
            ],
            applyTo: "All"
        }, {
            id: "textAdjust",
            name: "Text Adjust",
            dataType: 'Enum',
            values: [
                {text: "", value: ""},
                {text: "Cut Text", value: "CutText"},
                {text: "Stretch Height", value: "StretchHeight"},
                {text: "Scale Font", value: "ScaleFont"},
            ],
            applyTo: "Text"
        }, {
            id: "horizontalTextAlign",
            name: "Horizontal Text Align",
            dataType: 'Enum',
            attrName: "align",
            values: [
                {text: "", value: ""},
                {text: "Left", value: "left"},
                {text: "Center", value: "center"},
                {text: "Right", value: "right"},
                {text: "Justified", value: "justified"},
            ],
            applyTo: "Text"
        }, {
            id: "verticalTextAlign",
            name: "Vertical Text Align",
            dataType: 'Enum',
            attrName: "verticalAlign",
            values: [
                {text: "", value: ""},
                {text: "Top", value: "top"},
                {text: "Middle", value: "middle"},
                {text: "Bottom", value: "bottom"},
                {text: "Justified", value: "justified"},
            ],
            applyTo: "Text"
        }, {
            id: "mode",
            name: "Mode",
            dataType: 'Enum',
            values: [
                {text: "", value: ""},
                {text: "Opaque", value: "Opaque"},
                {text: "Transparent", value: "Transparent"},
            ],
            applyTo: "All"
        }, {
            id: "onErrorType",
            name: "On Error Type",
            dataType: 'Enum',
            values: [
                {text: "", value: ""},
                {text: "Error", value: "Error"},
                {text: "Blank", value: "Blank"},
                {text: "Icon", value: "Icon"},
            ],
            applyTo: "Image"
        }, {
            id: "horizontalImageAlign",
            name: "Horizontal Image Align",
            dataType: 'Enum',
            values: [
                {text: "", value: ""},
                {text: "Left", value: "left"},
                {text: "Center", value: "center"},
                {text: "Right", value: "right"},
            ],
            applyTo: "Image"
        }, {
            id: "verticalImageAlign",
            name: "Vertical Image Align",
            dataType: 'Enum',
            values: [
                {text: "", value: ""},
                {text: "Top", value: "top"},
                {text: "Middle", value: "middle"},
                {text: "Bottom", value: "bottom"},
            ],
            applyTo: "Image"
        }, {
            id: "backcolor",
            name: "Backgroud Color",
            dataType: 'Color',
            applyTo: "Text",
            parentAttrName: "fill"
        }, {
            id: "forecolor",
            name: "Foreground Color",
            dataType: 'Color',
            applyTo: "Text",
            attrName: 'fill'
        }, {
            id: "blankWhenNull",
            name: "Blank When Null",
            dataType: 'Boolean',
            applyTo: "Text"
        }, {
            id: "bold",
            name: "Bold",
            dataType: 'Boolean',
            attrName: "fontStyle",
            applyTo: "Text"
        }, {
            id: "borderWidth",
            name: "Border Width",
            dataType: 'Number',
            step: 0.5,
            min: 0.0,
            max: 5,
            applyTo: "Text",
            parentAttrName: "strokeWidth"
        }, {
            id: "fontSize",
            name: "Font Size",
            dataType: 'Number',
            step: 2,
            min: 8,
            max: 64,
            applyTo: "Text",
        }]
        that.GUIDELINE_OFFSET = 5;
        that.fetchReportDetails((data) => that.drawWidgets(data));
        that.view.find("#saveBtn").click(() => {
            that.onSaveClicked(() => {
                notifier.showSuccess("Saved Successfully")
            });
        });
        that.view.find("#saveAndExitBtn").click(() => {
            that.onSaveClicked(() => {
                let editPlace = new EditPlace({});
                editPlace.entityType = that.entity;
                editPlace.view = ViewMode.EDIT;
                editPlace.id = that.reportWizardId;
                NamaRouterInstance.goTo(editPlace);
            });
        });
    }

    onSaveClicked(callback) {
        let that = this;
        ajaxJSON("reportdetails", {
            action: "done",
            reportWizardId: that.reportWizardId,
            entity: that.entity,
            data: that.canvas.stage.toJSON()
        }, callback);
    }


    initEditor() {
        let editorTemplate = $(ReportWizardEditorTemplate({translateId: ts.translateId}));
        let domBody = $('#example');
        this.view = editorTemplate.appendTo(domBody);
        window.document.body.style.backgroundImage = 'none';
    }

    fetchReportDetails(callback) {
        ajaxJSON("reportdetails", {
            reportWizardId: this.reportWizardId,
            entity: this.entity
        }, (data) => {
            callback(data);
        });
    }

    /***
     *
     * @param data {namaTypes.ReportDetailsResponse}
     */
    drawWidgets(data) {
        let canvas = this.canvas = new NamaKonvaCanvas({
            containerId: "editorParent",
            width: data.pageWidth + this.bandSelectorWidth,
            height: data.pageHeight,
            shouldAddSelector: true,
            backgroundGridCellWidth: 10,
            backgroundGridCellHeight: 10,
            ignoreXPixelsInBackground: this.bandSelectorWidth,
            ignoreYPixelsInBackground: 0
        });
        canvas.topMargin = data.topMargin;
        canvas.bottomMargin = data.bottomMargin;
        canvas.leftMargin = data.leftMargin;
        canvas.rightMargin = data.rightMargin;
        this.view.find(".my-container").css("height", $(window).height() - ($(".navbar").height() + 5));
        canvas.draw();
        this.bandsNodes = [];
        this.bandsSelectors = [];
        this.selectableShapes = [];
        let currentY = data.topMargin;
        for (let band of data.bands) {
            this.drawBand(band, data, currentY)
            currentY += band.height;
        }
        this.zoomRatio = 100;
        this.appendBandsTransformerToLayer();
        this.considerZooming(canvas)
    }

    appendBandsTransformerToLayer() {
        let tr = this.bandsTransformer = new Konva.Transformer({
            rotateEnabled: false,
            draggable: false,
            // shouldOverdrawWholeArea: true,
            enabledAnchors: ['bottom-center'],
        });
        this.canvas.transformers.push(tr);
        tr.boundBoxFunc(function (oldBox, newBox) {
            if (newBox.height < 10) {
                tr.stopTransform();
                return oldBox;
            }
            return newBox;
        });
        let stage = this.canvas.stage;
        let selectionRectangle = this.canvas.selectionRectangle;
        stage.on('click tap', (e) => {
            let x = stage.getPointerPosition().x;
            if (x <= this.bandSelectorWidth)
                return;
            let target = this.findClosestChildShape(e.target);
            if (!target) {
                tr.nodes([]);
                if (e.target instanceof Konva.Stage) {
                    this.view.find("#propertyName").text('Report');
                    kendo.destroy(this.view.find("#props"));
                    this.view.find("#props").empty();
                    this.view.find("#props").append(
                        `<div class="d-flex justify-content-between px-2 py-1">
                        <label for="pageWidth">Page Width</label>&ensp;
                        <input type="number" min="0" max="3000" step="1" id="pageWidthInput" 
                        value="${Math.round((this.canvas.stage.width() / this.canvas.stage.scaleX()) - this.bandSelectorWidth)}" class="numberInput width-50 text-center">
                        </div>
                        <div class="d-flex justify-content-between px-2 py-1">
                        <label for="pageHeight">Page Height</label>&ensp;
                        <input type="number" min="0" max="3000" step="1" id="pageHeightInput" 
                        value="${Math.round(this.canvas.stage.height() / this.canvas.stage.scaleY())}" class="numberInput width-50 text-center">
                        </div>
                        <div class="d-flex justify-content-between px-2 py-1">
                        <label for="topMargin">Top Margin</label>&ensp;
                        <input type="number" min="0" max="100" step="1" id="topMarginInput" 
                        value="${this.canvas.topMargin}" class="numberInput width-50 text-center">
                        </div>
                        <div class="d-flex justify-content-between px-2 py-1">
                        <label for="bottomMargin">Bottom Margin</label>&ensp;
                        <input type="number" min="0" max="100" step="1" id="bottomMarginInput" 
                        value="${this.canvas.bottomMargin}" class="numberInput width-50 text-center">
                        </div>
                        <div class="d-flex justify-content-between px-2 py-1">
                        <label for="leftMargin">Left Margin</label>&ensp;
                        <input type="number" min="0" max="100" step="1" id="leftMarginInput" 
                        value="${this.canvas.leftMargin}" class="numberInput width-50 text-center">
                        </div>
                        <div class="d-flex justify-content-between px-2 py-1">
                        <label for="rightMargin">Right Margin</label>&ensp;
                        <input type="number" min="0" max="100" step="1" id="rightMarginInput" 
                        value="${this.canvas.rightMargin}" class="numberInput width-50 text-center">
                        </div>`)
                    this.view.find("#pageWidthInput").on('change', (e) => {
                        this.redrawCanvas({width: Number.parseInt(e.target.value)})
                    })
                    this.view.find("#pageHeightInput").on('change', (e) => {
                        this.redrawCanvas({height: Number.parseInt(e.target.value)})
                    })
                    this.view.find("#topMarginInput").on('change', (e) => {
                        this.redrawCanvas({topMargin: Number.parseInt(e.target.value)})
                    })
                    this.view.find("#bottomMarginInput").on('change', (e) => {
                        this.redrawCanvas({bottomMargin: Number.parseInt(e.target.value)})
                    })
                    this.view.find("#leftMarginInput").on('change', (e) => {
                        this.redrawCanvas({leftMargin: Number.parseInt(e.target.value)})
                    })
                    this.view.find("#rightMarginInput").on('change', (e) => {
                        this.redrawCanvas({rightMargin: Number.parseInt(e.target.value)})
                    })
                }
                return;
            } else {
                this.view.find("#propertyName").text("Nothing selected");
                kendo.destroy(this.view.find("#props"));
                this.view.find("#props").empty();
            }
            // if we are selecting with rect, do nothing
            if (selectionRectangle.visible() && selectionRectangle.width() > 0) {
                return;
            }

            if (this.canvas.pointerInsideTransformRectangle())
                return;
            // if click on a design element, not a band do nothing

            if (this.canvas.findClosestChildShape(e.target)) {
                return;
            }

            if (target) {
                tr.nodes([target]);
                tr.moveToTop();
                this.canvas.transformer.nodes([]);
            } else
                tr.nodes([]);

        });
        this.canvas.layer.add(tr);
    }

    redrawCanvas(attrs) {
        if (attrs.width !== undefined) {
            let newWidth = attrs.width;
            this.canvas.stage.width((newWidth + this.bandSelectorWidth) * this.canvas.stage.scaleX());
            this.bandsNodes.forEach((node) => {
                let newBandWidth = newWidth - (this.canvas.leftMargin + this.canvas.rightMargin);
                node.width(newBandWidth);
                node.getChildren()[0].width(newBandWidth);
            });
            this.redrawBackgroundGrid();
        }
        if (attrs.height !== undefined) {
            let newHeight = attrs.height;
            this.canvas.stage.height(newHeight * this.canvas.stage.scaleY());
            this.redrawBackgroundGrid();
        }
        if (attrs.topMargin !== undefined) {
            let topMargin = attrs.topMargin;
            this.canvas.topMargin = topMargin;
            this.bandsNodes.forEach((node) => {
                node.y(topMargin);
                topMargin += node.height();
            });
            topMargin = attrs.topMargin;
            this.bandsSelectors.forEach((node) => {
                node.y(topMargin);
                topMargin += node.height();
            });
        }
        if (attrs.leftMargin !== undefined) {
            let leftMargin = attrs.leftMargin;
            this.canvas.leftMargin = leftMargin;
            this.bandsNodes.forEach((node) => {
                node.x(leftMargin + this.bandSelectorWidth);
                let newBandWidth = (this.canvas.stage.width() - node.x() - this.canvas.rightMargin) / this.canvas.stage.scaleX();
                node.width(newBandWidth)
                node.getChildren()[0].width(newBandWidth);
            });
        }
        if (attrs.rightMargin !== undefined) {
            let rightMargin = attrs.rightMargin;
            this.canvas.rightMargin = rightMargin;
            this.bandsNodes.forEach((node) => {
                let newBandWidth = (this.canvas.stage.width() - node.x() - rightMargin) / this.canvas.stage.scaleX();
                node.width(newBandWidth)
                node.getChildren()[0].width(newBandWidth);
            });
        }
        if (attrs.bottomMargin !== undefined) {
            this.canvas.bottomMargin = attrs.bottomMargin;
        }
    }

    redrawBackgroundGrid() {
        this.canvas.layer.find('Line').forEach(node => node.destroy());
        this.canvas.drawBackgroundGrid(this.canvas.backgroundGridCellWidth, this.canvas.backgroundGridCellHeight);
    }

    /**
     *
     * @param node {Konva.Node}
     */
    findClosestChildShape(node) {
        if (!node || node instanceof Konva.Layer || node instanceof Konva.Stage)
            return null;
        if (this.selectableShapes.includes(node))
            return node;
        return this.findClosestChildShape(node.parent);
    }

    drawBand(band, data, currentY) {
        let that = this;
        let columnWidth = data.pageWidth - (data.leftMargin + data.rightMargin);
        let bandGroup = new Konva.Group({
            width: columnWidth,
            height: band.height,
            draggable: false,
            x: this.bandSelectorWidth + data.leftMargin,
            y: currentY,
            id: band.name
        });
        let rect = null;
        bandGroup.add(rect = new Konva.Rect({
            width: columnWidth,
            height: band.height,
            x: 0,
            y: 0,
            stroke: "rgba(8, 58, 169,0.7)",
            strokeWidth: 0.4,
        }),)
        let bandSelector = new Konva.Group({
            bandId: band.name,
            band: rect,
            height: band.height,
            width: this.bandSelectorWidth,
            x: 0,
            y: currentY,
            draggable: false,
        });
        bandSelector.add(new Konva.Rect({
            width: this.bandSelectorWidth,
            height: band.height,
            fill: 'grey',
            stroke: '#FFFFFF',
            strokeWidth: .2
        }))
        bandSelector.add(new Konva.Text({
            fontSize: 10,
            fontStyle: 'bold',
            fill: '#FFFFFF',
            height: band.height,
            width: this.bandSelectorWidth,
            text: '↕',
            align: 'center',
            verticalAlign: 'middle',
        }))
        bandSelector.on('click tap', function () {
            let bandNode = bandSelector.getAttr('band');
            if (that.bandsTransformer.nodes().includes(bandNode))
            {
                that.bandsTransformer.nodes([])
            }
            else
            {
                that.bandsTransformer.nodes([bandNode]);
                that.canvas.transformer.nodes([]);
            }
        })
        this.appendElementsToGroup(bandGroup, band.elements)
        this.canvas.addShapesToLayer(bandSelector);
        this.canvas.addShapesToLayer(bandGroup);
        this.bandsNodes.push(bandGroup);
        this.bandsSelectors.push(bandSelector);
        this.selectableShapes.push(rect);
        bandSelector.on('mouseenter', () => {
            this.canvas.stage.container().style.cursor = 'move';
        });

        bandSelector.on('mouseleave', () => {
            this.canvas.stage.container().style.cursor = 'default';
        });
        rect.on('transform', () => {
                let newHeight = rect.scaleY() * rect.height();
                let children = bandGroup.getChildren();
                for (let child of children) {
                    if (child !== rect && child.height() > newHeight) {
                        newHeight = child.height();
                        that.bandsTransformer.stopTransform();
                        break;
                    }
                }
                rect.setAttrs({
                    height: newHeight, scaleX: 1, scaleY: 1, rotation: 0
                });
                bandSelector.height(newHeight);
                bandSelector.getChildren()[0].height(newHeight);
                bandSelector.getChildren()[1].height(newHeight);
                bandGroup.height(newHeight);
                let currentY = this.bandsNodes[0].y() + this.bandsNodes[0].height();
                for (let i = 1; i < this.bandsNodes.length; i++) {
                    this.bandsNodes[i].y(currentY);
                    this.bandsSelectors[i].y(currentY);
                    currentY += this.bandsNodes[i].height();
                }
                let lastBandNode = this.bandsNodes[this.bandsNodes.length - 1];
                if (lastBandNode.y() + lastBandNode.height() >= that.canvas.stage.height()) {
                    that.bandsTransformer.stopTransform();
                }
            }
        );
    }

    appendElementsToGroup(bandGroup, elements) {
        for (let element of elements) {
            let elementWidth = element.width;
            let elementHeight = element.height;
            let elementGroup = new Konva.Group({
                id: element.namaId,
                name: "object",
                expression: element.expression,
                arabicText: element.arabicText,
                englishText: element.englishText,
                height: elementHeight,
                width: elementWidth,
                x: element.x,
                y: element.y,
                draggable: true,
            });
            elementGroup.add(new Konva.Rect({
                width: elementWidth,
                height: elementHeight,
                fill: element.backcolor,
                stroke: "black",
                strokeWidth: element.borderWidth
            }))
            if (element.namaId.startsWith('Component-Logo')) {
                let url = "./file.download?fileID=bgImag";
                if (APP_URL)
                    url = "http://localhost:8080/erp/file.download?fileID=bgImag";
                Konva.Image.fromURL(url, function (image) {
                    image.setAttrs({
                        height: elementHeight,
                        width: elementWidth,
                        scaleX: 1,
                        scaleY: 1,
                        name: 'main',
                        mode: element.mode,
                        onErrorType: element.onErrorType,
                        stretchType: element.stretchType,
                        horizontalImageAlign: element.horizontalImageAlign.toLowerCase(),
                        verticalImageAlign: element.verticalImageAlign.toLowerCase()
                    });
                    elementGroup.add(image)
                })
            } else {
                elementGroup.add(new Konva.Text({
                    fontSize: element.fontSize,
                    fill: element.forecolor,
                    height: elementHeight,
                    width: elementWidth,
                    text: element.namaId,
                    align: element.horizontalTextAlign.toLowerCase(),
                    verticalAlign: element.verticalTextAlign.toLowerCase(),
                    horizontalTextAlign: element.horizontalTextAlign,
                    verticalTextAlign: element.verticalTextAlign,
                    fontStyle: element.bold ? 'bold' : 'normal',
                    name: 'main',
                    blankWhenNull: element.blankWhenNull,
                    mode: element.mode,
                    stretchType: element.stretchType,
                    textAdjust: element.textAdjust
                }))
            }
            this.appendTooltipEvents(elementGroup);
            this.appendDraggingEvent(elementGroup, bandGroup);
            this.appendTransFromEvent(elementGroup, bandGroup);
            bandGroup.add(elementGroup);
            this.canvas.addShapesToSelectableList(elementGroup)
        }
        this.appendSelectionCallback();
    }

    appendSelectionCallback() {
        this.canvas.selectionCallback = (nodes) => {
            if (nodes.length === 0 && this.view.find("#propertyName").text() === 'Report') {
                return;
            }
            this.view.find("#propertyName").text("Nothing selected");
            kendo.destroy(this.view.find("#props"));
            this.view.find("#props").empty();
            let elementGroup = nodes[0]
            if (!elementGroup)
                return;
            this.bandsTransformer.nodes([]);
            let mainNode = elementGroup.getChildren().filter(l => l.hasName('main'))[0]
            this.view.find("#propertyName").text(elementGroup.id());
            if (mainNode) {
                for (let property of this.enumsProperties) {
                    if (property.applyTo === mainNode.getClassName() || property.applyTo === 'All') {
                        if (property.dataType === 'Enum') {
                            let attrName = property.attrName ? property.attrName : property.id;
                            this.view.find("#props").append(
                                `<div class="d-flex justify-content-between  px-2 py-1">
                            <label for="${attrName}">${property.name}</label>&ensp;
                            <input id="${attrName}" class="width-50 text-center">
                        </div>`)
                            let dropDown = $(`#${attrName}`).kendoDropDownList({
                                dataValueField: "value",
                                dataTextField: "text",
                                dataSource: property.values,
                                change: function (e) {
                                    for (let node of nodes) {
                                        let mainNode = node.getChildren().filter(l => l.hasName('main'))[0]
                                        let newValue = e.sender.value();
                                        if (mainNode.getAttr(property.id) !== undefined)
                                            mainNode.setAttr(property.id, newValue)
                                        if (mainNode.getAttr(property.attrName) !== undefined)
                                            mainNode.setAttr(property.attrName, newValue)
                                    }
                                }
                            }).data("kendoDropDownList");
                            let selectedValue = mainNode.getAttr(attrName) ? mainNode.getAttr(attrName) : '';
                            dropDown.value(selectedValue)
                        } else if (property.dataType === 'Color') {
                            let attrName = property.attrName ? property.attrName : property.id;
                            let value = mainNode.getAttr(attrName);
                            if (!value) {
                                let rectNode = this.canvas.fetchFirstChildWithClassName(elementGroup, 'Rect')
                                value = rectNode.getAttr(property.parentAttrName);
                            }
                            this.view.find("#props").append(
                                `<div class="d-flex justify-content-between  px-2 py-1">
                            <label for="${attrName}">${property.name}</label>&ensp;
                            <input type="color" id="${attrName}" value="${value}" class="colorInput width-50 text-center">
                        </div>`)
                            $(`#${attrName}.colorInput`).on('change', (e) => {
                                for (let node of nodes) {
                                    let mainNode = node.getChildren().filter(l => l.hasName('main'))[0]
                                    if (property.attrName) {
                                        mainNode.setAttr(attrName, e.target.value)
                                    } else if (property.parentAttrName) {
                                        let rectNode = this.canvas.fetchFirstChildWithClassName(node, 'Rect')
                                        rectNode.setAttr(property.parentAttrName, e.target.value)
                                    }
                                    mainNode.moveToTop();
                                }
                            })
                        } else if (property.dataType === 'Boolean') {
                            let attrName = property.attrName ? property.attrName : property.id;
                            let value = mainNode.getAttr(attrName) ? 'checked' : '';
                            if (property.attrName)
                                value = mainNode.getAttr(property.attrName) === 'bold' ? 'checked' : '';
                            this.view.find("#props").append(
                                `<div class="d-flex justify-content-between  px-2 py-1">
                                <label for="${attrName}">${property.name}</label>&ensp;
                                <input type="checkbox" id="${attrName}" ${value} class="checkboxInput width-50 text-center">
                                </div>`)
                            $(`#${attrName}.checkboxInput`).on('change', (e) => {
                                for (let node of nodes) {
                                    let mainNode = node.getChildren().filter(l => l.hasName('main'))[0]
                                    if (property.attrName) {
                                        e.target.checked ?
                                            mainNode.setAttr(property.attrName, 'bold') :
                                            mainNode.setAttr(property.attrName, 'normal');
                                    } else {
                                        mainNode.setAttr(attrName, e.target.checked)
                                    }
                                }
                            })
                        } else if (property.dataType === 'Number') {
                            let attrName = property.attrName ? property.attrName : property.parentAttrName ? property.parentAttrName : property.id;
                            let value = mainNode.getAttr(attrName);
                            if (property.parentAttrName) {
                                let rectNode = this.canvas.fetchFirstChildWithClassName(elementGroup, 'Rect')
                                value = rectNode.getAttr(property.parentAttrName);
                            }
                            this.view.find("#props").append(
                                `<div class="d-flex justify-content-between  px-2 py-1">
                                        <label for="${attrName}">${property.name}</label>&ensp;
                                        <input type="number" min="${property.min}" max="${property.max}" step="${property.step}" id="${attrName}" value="${value}" class="numberInput width-50 text-center">
                                        </div>`)
                            $(`#${attrName}.numberInput`).on('change', (e) => {
                                for (let node of nodes) {
                                    let mainNode = node.getChildren().filter(l => l.hasName('main'))[0]
                                    if (property.parentAttrName) {
                                        let rectNode = this.canvas.fetchFirstChildWithClassName(node, 'Rect')
                                        rectNode.setAttr(property.parentAttrName, +e.target.value);
                                    } else {
                                        mainNode.setAttr(attrName, +e.target.value)
                                    }
                                    mainNode.moveToTop()
                                }
                            })
                        }
                    }
                }
                this.appendSelectedNodesTextAreaToView();
                let activeNodes = this.canvas.transformer.nodes();
                if (activeNodes.length > 1) {
                    let buttons = [{
                        label: 'Align Components',
                        id: 'alignComponentsContainer',
                        buttons: [{
                            id: 'alignComponentsTop',
                            label: 'Align Top'
                        }, {
                            id: 'alignComponentsBottom',
                            label: 'Align Bottom'
                        }]
                    }, {
                        label: 'Align In Container',
                        id: 'alignInContainerContainer',
                        buttons: [{
                            id: 'alignInContainerTop',
                            label: 'Align Top'
                        }, {
                            id: 'alignInContainerBottom',
                            label: 'Align Bottom'
                        }]
                    }, {
                        label: 'Change Width',
                        id: 'changeWidthContainer',
                        buttons: [{
                            id: 'matchMaxWidth',
                            label: 'Match Max Width'
                        }, {
                            id: 'matchMinWidth',
                            label: 'Match Min Width'
                        }]
                    }, {
                        label: 'Change Height',
                        id: 'changeHeightContainer',
                        buttons: [{
                            id: 'matchMaxHeight',
                            label: 'Match Max Height'
                        }, {
                            id: 'matchMinHeight',
                            label: 'Match Min Height'
                        }]
                    }, {
                        label: 'Join',
                        id: 'joinContainer',
                        buttons: [{
                            id: 'joinLeft',
                            label: 'Join Left'
                        }, {
                            id: 'joinRight',
                            label: 'Join Right'
                        }]
                    }]
                    buttons.forEach(e => {
                        this.view.find("#props").append(`
                            <div class="d-flex justify-content-between align-items-center px-2 py-1">
                            <label>${e.label}</label>&ensp;
                            <div id="${e.id}" class="d-flex width-70 align-items-center px-2 py-1">
                            </div></div>`)
                        e.buttons.forEach(btn => {
                            this.view.find(`#${e.id}`).append(`
                                <button id="${btn.id}" class="btn btn-sm btn-secondary mx-2">${btn.label}</button>
                            `)
                        })
                    })
                    this.view.find("#alignInContainerTop").on('click', () => {
                        activeNodes.forEach(node => node.y(0))
                    })
                    this.view.find("#alignInContainerBottom").on('click', () => {
                        activeNodes.forEach(node => node.y(node.getParent().height() - node.height()))
                    })
                    this.view.find("#matchMaxWidth").on('click', () => {
                        let maxWidth = Math.max(...activeNodes.map(n => n.width()));
                        activeNodes.forEach(node => {
                            node.width(maxWidth)
                            node.getChildren().forEach(l => l.width(maxWidth))
                        });
                    })
                    this.view.find("#matchMinWidth").on('click', () => {
                        let minWidth = Math.min(...activeNodes.map(n => n.width()));
                        activeNodes.forEach(node => {
                            node.getChildren().forEach(l => l.width(minWidth))
                            node.width(minWidth)
                        });
                    })
                    this.view.find("#matchMaxHeight").on('click', () => {
                        let maxHeight = Math.max(...activeNodes.map(n => n.height()));
                        activeNodes.forEach(node => {
                            node.height(maxHeight)
                            node.getChildren().forEach(l => l.height(maxHeight))
                        });
                    })
                    this.view.find("#matchMinHeight").on('click', () => {
                        let minHeight = Math.min(...activeNodes.map(n => n.height()));
                        activeNodes.forEach(node => {
                            node.height(minHeight)
                            node.getChildren().forEach(l => l.height(minHeight))
                        });
                    })
                    this.view.find("#alignComponentsTop").on('click', () => {
                        let nodesByParent = this.getNodesFilteredByParent(activeNodes);
                        for (let parent in nodesByParent) {
                            let y = Math.min(...nodesByParent[parent].map(n => n.y()));
                            nodesByParent[parent].forEach(n => n.y(y));
                        }
                    });
                    this.view.find("#alignComponentsBottom").on('click', () => {
                        let nodesByParent = this.getNodesFilteredByParent(activeNodes);
                        for (let parent in nodesByParent) {
                            let y = Math.max(...nodesByParent[parent].map(n => n.y()));
                            nodesByParent[parent].forEach(n => n.y(y))
                        }
                    });
                    this.view.find("#joinLeft").on('click', () => {
                        let nodesByParent = this.getNodesFilteredByParent(activeNodes);
                        for (let parent in nodesByParent) {
                            let sortedByX = nodesByParent[parent].sort((a, b) => a.x() - b.x());
                            let currentX = sortedByX[0].x() + sortedByX[0].width();
                            for (let i = 1; i < sortedByX.length; i++) {
                                sortedByX[i].x(currentX);
                                currentX += sortedByX[i].width();
                            }
                        }
                    });
                    this.view.find("#joinRight").on('click', () => {
                        let nodesByParent = this.getNodesFilteredByParent(activeNodes);
                        for (let parent in nodesByParent) {
                            let sortedByX = nodesByParent[parent].sort((a, b) => b.x() - a.x());
                            let currentX = sortedByX[0].x();
                            for (let i = 1; i < sortedByX.length; i++) {
                                let currentNode = sortedByX[i];
                                currentNode.x(currentX - currentNode.width());
                                currentX -= currentNode.width();
                            }
                        }
                    });
                }
            }
            this.view.find("#props").append(`
                <div class="d-flex justify-content-between align-items-center px-2 py-1">
                <label>Stretch To Container</label>&ensp;
                <div class="d-flex width-70 align-items-center px-2 py-1">
                <button id="stretchHeight" class="btn btn-sm btn-secondary mx-2">Stretch Height</button>
                </div>
                </div>`)
            this.view.find("#stretchHeight").on('click', () => {
                let activeNodes = this.canvas.transformer.nodes();
                activeNodes.forEach(node => {
                    node.y(0);
                    let containerHeight = node.getParent().height();
                    node.height(containerHeight);
                    node.getChildren().forEach(l => l.height(containerHeight));
                })
                this.canvas.transformer.nodes([])
                this.canvas.transformer.nodes(activeNodes)
            })
        }
    }

    getNodesFilteredByParent(activeNodes) {
        let parents = {};
        for (let i = 0; i < activeNodes.length; i++) {
            let current = activeNodes[i];
            let parentId = current.getParent().getAttr('id');
            if (parents[parentId])
                parents[parentId].push(current);
            else
                parents[parentId] = [current];
        }
        return parents;
    }

    appendSelectedNodesTextAreaToView() {
        this.view.find("#props").append(`
            <div class="d-flex justify-content-between  px-2 py-1">
            <label for="selectedNodes">Selected Nodes</label>&ensp;
            <div class="d-flex width-70 align-items-center px-2 py-1">
            <textarea id="selectedNodes" style="width: 100%" disabled></textarea>
            </div>
            </div>`);
        let value = '';
        let rows = this.canvas.transformer.nodes().length;
        this.canvas.transformer.nodes().forEach((n) => {
            value += '-' + n.getAttr('id') + '\n';
        })
        this.view.find('#selectedNodes').attr('rows', rows);
        this.view.find('#selectedNodes').val(value);
    }

    appendTransFromEvent(elementGroup, bandGroup) {
        elementGroup.on('transform', () => {
            let x = elementGroup.x();
            let y = elementGroup.y();
            let newWidth = elementGroup.scaleX() * elementGroup.width();
            let newHeight = elementGroup.scaleY() * elementGroup.height();
            if (x < 0)
                x = 0;
            if (y < 0)
                y = 0;
            if (elementGroup.scaleY())
                if (x + newWidth > bandGroup.width())
                    newWidth = bandGroup.width() - x;
            if (y + newHeight > bandGroup.height())
                newHeight = bandGroup.height() - y;
            elementGroup.setAttrs({
                x: x, y: y, width: newWidth, height: newHeight, scaleX: 1, scaleY: 1, rotation: 0
            });
                for (let shape of elementGroup.children) {
                    shape.setAttrs({
                        x: 0, y: 0, width: newWidth, height: newHeight, scaleX: 1, scaleY: 1, rotation: 0
                    });
                }
            }
        );
    }

    appendDraggingEvent(elementGroup, bandGroup) {
        elementGroup.on('dragmove', () => {
            const position = elementGroup.absolutePosition();

            let y = position.y / this.canvas.stage.scaleY();
            let x = position.x / this.canvas.stage.scaleX();
            if (y < bandGroup.y())
                elementGroup.y(0);
            if (y + elementGroup.height() > bandGroup.y() + bandGroup.height())
                elementGroup.y(bandGroup.height() - elementGroup.height());
            if (x < bandGroup.x())
                elementGroup.x(0);
            if (x + elementGroup.width() > bandGroup.x() + bandGroup.width())
                elementGroup.x(bandGroup.width() - elementGroup.width());
            this.appendSnippingAndGuideLines(elementGroup, bandGroup);
        });

        this.canvas.layer.on('dragend', () => {
            // clear all previous lines on the screen
            this.canvas.layer.find('.guid-line').forEach((l) => l.destroy());
        });
    }

    appendSnippingAndGuideLines(elementGroup, bandGroup) {
        // clear all previous lines on the screen
        this.canvas.layer.find('.guid-line').forEach((l) => l.destroy());

        // find possible snapping lines
        let lineGuideStops = this.getLineGuideStops(elementGroup, bandGroup);
        // find snapping points of current object
        let itemBounds = this.getObjectSnappingEdges(elementGroup);

        // now find where can we snap current object
        let guides = this.getGuides(lineGuideStops, itemBounds);

        // do nothing of no snapping
        if (!guides.length) {
            return;
        }

        this.drawGuides(guides);

        let absPos = elementGroup.absolutePosition();
        // now force object position
        guides.forEach((lg) => {
            switch (lg.snap) {
                case 'start': {
                    switch (lg.orientation) {
                        case 'V': {
                            absPos.x = lg.lineGuide + lg.offset;
                            break;
                        }
                        case 'H': {
                            absPos.y = lg.lineGuide + lg.offset;
                            break;
                        }
                    }
                    break;
                }
                case 'center': {
                    switch (lg.orientation) {
                        case 'V': {
                            absPos.x = lg.lineGuide + lg.offset;
                            break;
                        }
                        case 'H': {
                            absPos.y = lg.lineGuide + lg.offset;
                            break;
                        }
                    }
                    break;
                }
                case 'end': {
                    switch (lg.orientation) {
                        case 'V': {
                            absPos.x = lg.lineGuide + lg.offset;
                            break;
                        }
                        case 'H': {
                            absPos.y = lg.lineGuide + lg.offset;
                            break;
                        }
                    }
                    break;
                }
            }
        });
        elementGroup.absolutePosition(absPos);
    }

// where can we snap our objects?
    getLineGuideStops(skipShape, parent) {
        // we can snap to stage borders and the center of the stage
        let vertical = [parent.y(), parent.width() / 2, parent.width(), this.canvas.stage.width() / 2, this.canvas.stage.width()];
        let horizontal = [parent.x(), parent.height() / 2, parent.height(), this.canvas.stage.height() / 2, this.canvas.stage.height()];

        // and we snap over edges and center of each object on the canvas
        this.canvas.stage.find('.object').forEach((guideItem) => {
            if (guideItem === skipShape) {
                return;
            }
            let box = guideItem.getClientRect();
            // and we can snap to all edges of shapes
            vertical.push([box.x, box.x + box.width, box.x + box.width / 2]);
            horizontal.push([box.y, box.y + box.height, box.y + box.height / 2]);
        });
        return {
            vertical: vertical.flat(),
            horizontal: horizontal.flat(),
        };
    }

    // what points of the object will trigger to snapping?
    // it can be just center of the object
    // but we will enable all edges and center
    getObjectSnappingEdges(node) {
        let box = node.getClientRect();
        let absPos = node.absolutePosition();

        return {
            vertical: [
                {
                    guide: Math.round(box.x),
                    offset: Math.round(absPos.x - box.x),
                    snap: 'start',
                },
                {
                    guide: Math.round(box.x + box.width / 2),
                    offset: Math.round(absPos.x - box.x - box.width / 2),
                    snap: 'center',
                },
                {
                    guide: Math.round(box.x + box.width),
                    offset: Math.round(absPos.x - box.x - box.width),
                    snap: 'end',
                },
            ],
            horizontal: [
                {
                    guide: Math.round(box.y),
                    offset: Math.round(absPos.y - box.y),
                    snap: 'start',
                },
                {
                    guide: Math.round(box.y + box.height / 2),
                    offset: Math.round(absPos.y - box.y - box.height / 2),
                    snap: 'center',
                },
                {
                    guide: Math.round(box.y + box.height),
                    offset: Math.round(absPos.y - box.y - box.height),
                    snap: 'end',
                },
            ],
        };
    }

    // find all snapping possibilities
    getGuides(lineGuideStops, itemBounds) {
        let resultV = [];
        let resultH = [];

        lineGuideStops.vertical.forEach((lineGuide) => {
            itemBounds.vertical.forEach((itemBound) => {
                let diff = Math.abs(lineGuide - itemBound.guide);
                // if the distance between guild line and object snap point is close we can consider this for snapping
                if (diff < this.GUIDELINE_OFFSET) {
                    resultV.push({
                        lineGuide: lineGuide,
                        diff: diff,
                        snap: itemBound.snap,
                        offset: itemBound.offset,
                    });
                }
            });
        });

        lineGuideStops.horizontal.forEach((lineGuide) => {
            itemBounds.horizontal.forEach((itemBound) => {
                let diff = Math.abs(lineGuide - itemBound.guide);
                if (diff < this.GUIDELINE_OFFSET) {
                    resultH.push({
                        lineGuide: lineGuide,
                        diff: diff,
                        snap: itemBound.snap,
                        offset: itemBound.offset,
                    });
                }
            });
        });

        let guides = [];

        // find closest snap
        let minV = resultV.sort((a, b) => a.diff - b.diff)[0];
        let minH = resultH.sort((a, b) => a.diff - b.diff)[0];
        if (minV) {
            guides.push({
                lineGuide: minV.lineGuide,
                offset: minV.offset,
                orientation: 'V',
                snap: minV.snap,
            });
        }
        if (minH) {
            guides.push({
                lineGuide: minH.lineGuide,
                offset: minH.offset,
                orientation: 'H',
                snap: minH.snap,
            });
        }
        return guides;
    }

    drawGuides(guides) {
        guides.forEach((lg) => {
            if (lg.orientation === 'H') {
                let line = new Konva.Line({
                    points: [-6000, 0, 6000, 0],
                    stroke: 'rgb(0, 161, 255)',
                    strokeWidth: 1,
                    name: 'guid-line',
                    dash: [4, 6],
                });
                this.canvas.layer.add(line);
                line.absolutePosition({
                    x: 0,
                    y: lg.lineGuide,
                });
            } else if (lg.orientation === 'V') {
                let line = new Konva.Line({
                    points: [0, -6000, 0, 6000],
                    stroke: 'rgb(0, 161, 255)',
                    strokeWidth: 1,
                    name: 'guid-line',
                    dash: [4, 6],
                });
                this.canvas.layer.add(line);
                line.absolutePosition({
                    x: lg.lineGuide,
                    y: 0,
                });
            }
        });
    }

    appendTooltipEvents(elementGroup) {
        let that = this;
        let canvasToolTip = that.canvas.getTooltipText();
        elementGroup.on('mousemove', function () {
            let mousePos = that.canvas.stage.getPointerPosition();
            let x = mousePos.x / that.canvas.stage.scaleX();
            let y = mousePos.y / that.canvas.stage.scaleY();
            that.canvas.tooltip.position({
                x: x + 8,
                y: y + 8,
            });
            let expression = elementGroup.getAttr("expression");
            let toolTipText = elementGroup.id() + '\n' + elementGroup.getAttr("arabicText") + '\n' + elementGroup.getAttr("englishText")
            if (expression)
                toolTipText += expression ? '\n' + expression : '';
            canvasToolTip.text(toolTipText);
            if (canvasToolTip.width() * that.canvas.stage.scaleX() >= 400)
                canvasToolTip.width(400 / that.canvas.stage.scaleX())
            if ((x + canvasToolTip.width()) * that.canvas.stage.scaleX() > that.canvas.stage.width())
                that.canvas.tooltip.position({
                    x: x - canvasToolTip.width(),
                    y: y + 8,
                });
            that.canvas.getTooltipRect().width(canvasToolTip.width());
            that.canvas.getTooltipRect().height(canvasToolTip.height());
            that.canvas.tooltip.moveToTop();
            window.setTimeout(() => that.canvas.tooltip.show(), 1000)
        });
        elementGroup.on('mouseout', function () {
            that.canvas.tooltip.hide();
            that.canvas.getTooltipRect().width(0);
            that.canvas.getTooltipRect().height(0);
            canvasToolTip.text('');
            canvasToolTip.width('auto');
        });
    }

    considerZooming(canvas) {
        let comboBox = this.view.find("#zoomRatio").kendoComboBox({
            dataTextField: "value",
            dataValueField: "value",
            dataSource: [
                {value: "25"},
                {value: "50"},
                {value: "75"},
                {value: "100"},
                {value: "125"},
                {value: "150"},
                {value: "200"},
            ],
            index: 3,
            suggest: true,
            change: (e) => {
                if (!e.sender.value())
                    return;
                let oldHeight = canvas.stage.height();
                let oldWidth = canvas.stage.width();
                let diff = e.sender.value() / this.zoomRatio;
                let newWidth = oldWidth * diff;
                let newHeight = oldHeight * diff
                let newScale = e.sender.value() / 100;
                canvas.stage.scale({x: newScale, y: newScale});
                canvas.stage.width(newWidth);
                canvas.stage.height(newHeight);
                this.zoomRatio = e.sender.value();
            }
        }).data("kendoComboBox");

        this.view.find("#zoomIn").on('click', () => {
            comboBox.value(+comboBox.value() + 5);
            comboBox.trigger("change");
        })

        this.view.find("#zoomOut").on('click', () => {
            comboBox.value(+comboBox.value() - 5)
            comboBox.trigger("change");
        })
    }
}